<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte nov tip davka:
    </h2>

    <TaxTypeForm
      @save="save"
      @cancel="cancel"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import TaxTypeForm from '@/components/TaxTypeForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    TaxTypeForm
  },
  mixins: [
    asyncDataStatus
  ],
  methods: {
    ...mapActions('taxTypes', ['saveItem']),
    save ({ data }) {
      saveItem(data, 'MyCompanyTaxTypes', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyTaxTypes' })
    }
  },
  created () {
    this.asyncDataStatus_fetched()
  }
}
</script>
